import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'

interface UseAddAdditionalAccountOptions {
  provider: ExternalIntegrationEnum
  onConnectSuccess?: (integrations: ExternalIntegration[]) => void
}

export const useAddAdditionalAccount = ({ onConnectSuccess }: UseAddAdditionalAccountOptions) => {
  const { connect } = useConnectAccountPopup()

  const handleAddAccount = (popup?: Window) => {
    connect(popup, {
      isAdditionalAccount: true,
      onConnect: (newIntegrations: ExternalIntegration[]) => {
        onConnectSuccess?.(newIntegrations)
      },
    })
  }

  return handleAddAccount
}
